<template>
  <div class="chat_room_internet_commerce_item_wrap">
    <div class="chat_room_internet_commerce_item">
      <div class="chat_table_box">
        <div class="chat_table_ttl">인터넷 견적 문의 드려요!</div>
        <div class="chat_table_sub">
          작성일: {{ getCreateAt(internetCommerceModel.userCreatedAt) }}
        </div>
      </div>
      <div class="chat_table_box">
        <dl>
          <dt class="color_3">가입유형</dt>
          <dd class="font_normal no_wrap">
            {{ internetCommerceModel.userJoinType }}
          </dd>
        </dl>
        <dl>
          <dt class="color_3">상품구성</dt>
          <dd class="font_normal">
            {{
              internetCommerceModel.storeId == '4485'
                ? ''
                : internetCommerceModel.userSpeed
            }}
            {{ internetCommerceModel.userItemUse
            }}{{ getPhoneJoin(internetCommerceModel.userPhoneJoin) }}
          </dd>
        </dl>
        <dl>
          <dt>희망통신사</dt>
          <dd class="font_normal" v-if="internetCommerceModel.userTelecom">
            {{ internetCommerceModel.userTelecom }}
          </dd>
          <dd class="font_normal" v-else>-</dd>
        </dl>
        <dl>
          <dt>기존통신사</dt>
          <dd class="font_normal">
            {{ internetCommerceModel.userCurTelecom || '-' }}
          </dd>
        </dl>
        <dl>
          <dt>설치지역</dt>
          <dd class="font_normal word_keep_break">
            {{ internetCommerceModel.userAreaFullName }}
          </dd>
        </dl>
      </div>
      <div class="chat_table_box top_line">
        <dl>
          <dt class="color_1 font_bold">통신사</dt>
          <dd class="font_normal">
            <div>
              {{ internetCommerceModel.ownerTelecom }}
            </div>
          </dd>
        </dl>
        <dl v-if="internetCommerceModel.itemInternet">
          <dt class="color_1 font_bold">요금제</dt>
          <dd class="font_normal">
            <div class="color_1" v-if="internetCommerceModel.itemInternet">
              [인터넷] {{ internetCommerceModel.itemInternet }}
            </div>
            <div class="color_1" v-if="internetCommerceModel.itemTv">
              [TV] {{ internetCommerceModel.itemTv }}
            </div>
          </dd>
        </dl>
        <dl>
          <dt class="color_1 font_bold">월 납부액</dt>
          <dd class="font_weight">
            <div class="color_5">
              {{ toCurrency(internetCommerceModel.ownerMonthPrice) }}원
            </div>
          </dd>
        </dl>
        <dl style="display:block;">
          <dt class="color_1 font_bold">혜택</dt>
          <dd class="color_6 font_bold" style="text-align:left;">
            <span v-if="internetCommerceModel.ownerCashSupport > 0"
              >{{ toCurrency(internetCommerceModel.ownerCashSupport) }}원
              현금</span
            >
            <span
              v-if="
                internetCommerceModel.ownerCashSupport > 0 &&
                  (internetCommerceModel.ownerGiftCardSupport > 0 ||
                    internetCommerceModel.ownerGiftItemSupport > 0)
              "
            >
              +
            </span>
            <span v-if="internetCommerceModel.ownerGiftCardSupport > 0"
              >{{ toCurrency(internetCommerceModel.ownerGiftCardSupport) }}원
              상품권</span
            >
            <span
              v-if="
                (internetCommerceModel.ownerCashSupport > 0 ||
                  internetCommerceModel.ownerGiftCardSupport > 0) &&
                  internetCommerceModel.ownerGiftItemSupport > 0
              "
            >
              +
            </span>
            <span v-if="internetCommerceModel.ownerGiftItemSupport > 0"
              >{{ toCurrency(internetCommerceModel.ownerGiftItemSupport) }}원
              사은품</span
            >
            <span
              v-if="
                internetCommerceModel.ownerCashSupport > 0 ||
                  internetCommerceModel.ownerGiftCardSupport > 0 ||
                  internetCommerceModel.ownerGiftItemSupport > 0
              "
            >
              지원</span
            >
          </dd>
        </dl>
      </div>
      <div
        class="chat_table_box top_line"
        v-if="internetCommerceModel.ownerMemoSupport.length > 0"
      >
        <div
          class="color_3"
          v-html="
            $options.filters.nl2br(internetCommerceModel.ownerMemoSupport)
          "
        ></div>
      </div>
    </div>
    <button
      class="btn bo fw800"
      @click.stop.prevent="formApply()"
      v-if="isCustomer"
    >
      가입신청서 작성하기
    </button>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
export default {
  props: {
    internetCommerceModel: Object,
    createdAt: String,
    isCustomer: Boolean,
    chatroom: Object,
  },
  data() {
    return {};
  },
  mounted() {},
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy-MM-dd');
    },
    formApply() {
      this.$router.push({
        name: 'InternetCommerce.ApplyForm',
        params: {
          mode: 'submit',
          storeId: this.internetCommerceModel.storeId,
          icqId: this.internetCommerceModel.icqId,
        },
      });
    },
    getPhoneJoin(phoneJoin) {
      if (phoneJoin == 'PHONE') {
        return '+휴대폰';
      } else if (phoneJoin == 'USIM') {
        return '+USIM';
      } else {
        return '';
      }
    },
  },
};
</script>

<style></style>
